import { useSelector } from "react-redux";
import { maskUsername } from "../../SysGuard/SysGuardCommonComp"
import { isEmpty, isNull } from "lodash";
import {
  renderNull,
} from "../../SysGuard/Dashboard/ContentPages/SysGuardColumnConfig";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import { startCase, camelCase } from 'lodash';
import { getTotalHierarcyKey, ACTIVE_USERS, ROLES, PUBLIC_DATA, DATA_ASSETS, OPEN_ANOMALIES, BEHAVIORMODEL, POLICY, LOCATION, COUNTRY, DATASOURCE, ACTIVITIES, USERS, ANOMALIES, ASSETS } from "../Popup/ActionTypes";
import { StatusMap } from "./DataguardConstant";
import { dataguard_icons } from "../../../components/common/utilities";

// Helper function to process text and remove content after the last |
const processAccessDetailText = (text) => {
  if (!text || typeof text !== 'string') return text;

  // Check if text contains the pattern [something | something]
  const regex = /\[([^\]]*)\|([^\]]*)\]/g;
  return text.replace(regex, (match, beforePipe, afterPipe) => {
    return `[${beforePipe.trim()}]`;
  });
};

export const RenderUserName = (params, isIncognito) => {
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div className="sys-guard-status data-guard-status">Unknown</div>;
  } else {
    const name = startCase(camelCase(params.value));
    if (isIncognito) {
      const maskedName = maskUsername(name);
      return <div className="sys-guard-status data-guard-status" title={maskedName}>{maskedName}</div>;
    } else {
      return (
        <div className="sys-guard-status data-guard-status" title={name}>
          {name}
        </div>
      );
    }
  }
};

const renderUserEmail = (params, isIncognito) => {
  if (isNull(params.value) || isEmpty(params.value)) {
    return <div className="sys-guard-status data-guard-status">Unknown</div>;
  } else {
    const email = params.value;
    if (isIncognito) {
      const maskedEmail = maskUsername(email);
      return <div className="sys-guard-status data-guard-status" title={maskedEmail}>{maskedEmail}</div>;
    } else {
      return (
        <div className="sys-guard-status data-guard-status" title={email}>
          {email}
        </div>
      );
    }
  }
};

const renderNormalText = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    return (
      <div className="sys-guard-client-ip" title={params.value}>
        {params.value}
      </div>
    );
  }
};

const renderSeverityChip = (params) => {
  if (isNull(params.value) || isEmpty(params.value)) {
    return renderNull();
  } else {
    const severity = params.value.toLowerCase();
    let chipClass = "default";
    let displayText = params.value;
    
    if (severity === "high") {
      chipClass = "error";
      displayText = "High";
    } else if (severity === "medium") {
      chipClass = "warning"; 
      displayText = "Medium";
    } else if (severity === "low") {
      chipClass = "default";
      displayText = "Low";
    }
    
    return (
      <Chip
        size="small"
        label={displayText}
        title={`${displayText} Severity`}
        className={`popup-severity severity-chip ${chipClass}`}
      />
    );
  }
};

const renderStmtHeader = () => {
  return (
    <div className="sys-guard-attempt-status-header" title="Access Details">
      Access Details
    </div>
  )
}

const extractInfoFromAccessDetail = (rawAccessDetail) => {
  const accessDetails = processAccessDetailText(rawAccessDetail);
  const matches = [...accessDetails.matchAll(/\[([^\]]+)\]/g)];
  const operationType = startCase(camelCase(matches[0]?.[1] || ""));
  const fileName = matches[1]?.[1] || "";
  return { operationType, fileName };
}

const isSQLType = (params) => {
  const row = params?.row;
  const rawAccessDetail = row?.accessDetail || params.value || "";
  const op = extractInfoFromAccessDetail(rawAccessDetail).operationType;
  if (!op && rawAccessDetail) {
    return true;
  }
  return false;
};

const renderOperationType = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    const row = params?.row;
    const rawAccessDetail = row?.accessDetail || params.value || "Unknown";
    const op = extractInfoFromAccessDetail(rawAccessDetail).operationType;
    const isFullStatement = !op && rawAccessDetail;
    
    if (isFullStatement) {
      return (
        <div
          className="sys-guard-status data-guard-status"
          title={rawAccessDetail}
          style={{
            width: '100%',
            minWidth: '250px',
            maxWidth: '400px',
            wordWrap: 'break-word'
          }}
        >
          {rawAccessDetail}
        </div>
      );
    }
    return (
      <div
        className="sys-guard-status data-guard-status"
        title={op}
      >
        {op}
      </div>
    );
  }
}

const renderFileName = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    const row = params?.row;
    const rawAccessDetail = row?.accessDetail || params.value || "Unknown";
    const fn = extractInfoFromAccessDetail(rawAccessDetail).fileName;
    return (
      <div
        className="sys-guard-status data-guard-status"
        title={fn}
      >
        {fn}
      </div>
    );
  }
}

const renderStmt = (params) => {
  if (isNull(params.value)) {
    return renderNull();
  } else {
    const row = params?.row;
    const rawAccessDetail = row?.accessDetail || params.value || "Unknown";
    const accessDetail = processAccessDetailText(rawAccessDetail);

    return (
      <Tooltip
        title={
          <div className="custom-tooltip-content">
            <div>
              <span>{accessDetail}</span>
            </div>
          </div>
        }
        placement="top"
        arrow
        classes={{ tooltip: "custom-tooltip-popup", arrow: "custom-arrow-popup" }}
      >
        <div
          className="sys-guard-status data-guard-status"
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.2",
            textAlign: "left",
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
          }}
        >
          {accessDetail}
        </div>
      </Tooltip>
    );
  }
};

export const TABLE_COLS = (incognito, category, rows = [], hideDataSource = false) => {
  switch (category) {
    case getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ACTIVITIES]):
      return activitiesLocationColumns(incognito, rows, hideDataSource);
    case getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, USERS]):
      return userLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ANOMALIES]):
      return anomaliesLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([LOCATION, COUNTRY, DATASOURCE, ASSETS]):
      return dataAssetsLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, USERS]):
      return userLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES]):
    case getTotalHierarcyKey([BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES]):
      return anomaliesLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS]):
    case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY]):
      return dataAssetsLocationColumns(incognito, true);
    case getTotalHierarcyKey([PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES]):
      return activitiesLocationColumns(incognito, rows, true);
    case getTotalHierarcyKey([ROLES, DATASOURCE, USERS]):
    case getTotalHierarcyKey([ROLES, DATASOURCE, ACTIVE_USERS]):
      return userLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([ROLES, DATASOURCE, ANOMALIES]):
      return anomaliesLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([ROLES, DATASOURCE, COUNTRY]):
      return activitiesLocationColumns(incognito, rows, hideDataSource);
    // ── Users page ──────────────────────────────────────────────────────────
    case getTotalHierarcyKey([USERS, DATASOURCE, ANOMALIES]):
      return anomaliesLocationColumns(incognito, hideDataSource);
    case getTotalHierarcyKey([USERS, DATASOURCE, COUNTRY]):
      return usersCountryColumns(incognito, hideDataSource);
    default:
      return [];
  }
}

const sortText = (v1, v2) => {
  const a = v1?.toString().toLowerCase() || "";
  const b = v2?.toString().toLowerCase() || "";
  return a.localeCompare(b);
};

export const userLocationColumns = (isIncognito, hideDataSource = false) => {
  const columns = [
    {
      field: "userName",
      headerName: "User Name",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => RenderUserName(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "userEmail",
      headerName: "Email",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderUserEmail(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "dataSourceName",
      headerName: "Data Source",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        if (isNull(params.value) || isEmpty(params.value)) {
          return renderNull();
        }
        const dataSourceType = params.row.dataSourceType;
        const dataSourceName = params.value;
        return (
          <div className="data-guard-accordion-type ds-col-container">
            <img
              className="ds-icon"
              title={dataSourceName}
              src={dataguard_icons[dataSourceType]}
              alt={dataSourceType}
            />
            <div title={dataSourceName}>{dataSourceName}</div>
          </div>
        );
      },
      sortComparator: sortText,
    },
    {
      field: "userCategory",
      headerName: "Type",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params, isIncognito),
      sortComparator: sortText,
    }
  ];
  
  return hideDataSource ? columns.filter(col => col.field !== "dataSourceName") : columns;
}

export const dataAssetsLocationColumns = (isIncognito, hideDataSource = false) => {
  const columns = [
    {
      field: "fileName",
      headerName: "File Name",
      flex: 3,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "owner",
      headerName: "Owner Name",
      flex: 1.7,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => RenderUserName(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "dataSourceName",
      headerName: "Data Source",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        if (isNull(params.value) || isEmpty(params.value)) {
          return renderNull();
        }
        const dataSourceType = params.row.dataSourceType;
        const dataSourceName = params.value;
        return (
          <div className="data-guard-accordion-type ds-col-container">
            <img
              className="ds-icon"
              title={dataSourceName}
              src={dataguard_icons[dataSourceType]}
              alt={dataSourceType}
            />
            <div title={dataSourceName}>{dataSourceName}</div>
          </div>
        );
      },
      sortComparator: sortText,
    },
  ];
  
  return hideDataSource ? columns.filter(col => col.field !== "dataSourceName") : columns;
};

export const anomaliesLocationColumns = (isIncognito, hideDataSource = false) => {
  const columns = [
    {
      field: "date",
      headerName: "Date",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("MM-DD-YYYY");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "time",
      headerName: "Time",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("HH:mm");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "username",
      headerName: "User Name",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => RenderUserName(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "dataSourceName",
      headerName: "Data Source",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        if (isNull(params.value) || isEmpty(params.value)) {
          return renderNull();
        }
        const dataSourceType = params.row.dataSourceType;
        const dataSourceName = params.value;
        return (
          <div className="data-guard-accordion-type ds-col-container">
            <img
              className="ds-icon"
              title={dataSourceName}
              src={dataguard_icons[dataSourceType]}
              alt={dataSourceType}
            />
            <div title={dataSourceName}>{dataSourceName}</div>
          </div>
        );
      },
      sortComparator: sortText,
    },
    {
      field: "policyName",
      headerName: "Policy Name",
      flex: 3,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "severity",
      headerName: "Severity",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderSeverityChip(params),
      sortComparator: sortText,
    },
    {
      field: "alertStatus",
      headerName: "Alert Status",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        if (isNull(params.value)) {
          return renderNull();
        } else {
          const status = StatusMap[params.value] || params.value;
          return (
            <div
              className="sys-guard-status dataguard-violation-text"
              title={status}
            >
              {status}
            </div>
          );
        }
      },
      sortComparator: sortText,
    }
  ];
  
  return hideDataSource ? columns.filter(col => col.field !== "dataSourceName") : columns;
}

export const activitiesLocationColumns = (isIncognito, rows = [], hideDataSource = false) => {
  const firstRow = rows[0];
  const hasFullStatement = firstRow && isSQLType({ row: firstRow });
  let operationTypeFlex = hasFullStatement ? 4 : 2;
  let fileNameFlex = hasFullStatement ? 1 : 3;
  if (!hideDataSource) {
    let hasSQL = false;
    let hasNonSQL = false;
    for (let i = 1; i < rows.length; i++) {
      if (isSQLType({ row: rows[i] })) {
        hasSQL = true;
      } else if (!isSQLType({ row: rows[i] })) {
        hasNonSQL = true;
      }
    }
    if (hasSQL && hasNonSQL) {
      operationTypeFlex = 3;
      fileNameFlex = 2;
    }
  }

  const columns = [
    {
      field: "date",
      headerName: "Date",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("MM-DD-YYYY");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "time",
      headerName: "Time",
      flex: 1.2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("HH:mm");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "username",
      headerName: "User Name",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => RenderUserName(params, isIncognito),
      sortComparator: sortText,
    },
    {
      field: "dataSourceName",
      headerName: "Data Source",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        if (isNull(params.value) || isEmpty(params.value)) {
          return renderNull();
        }
        const dataSourceType = params.row.dataSourceType;
        const dataSourceName = params.value;
        return (
          <div className="data-guard-accordion-type ds-col-container">
            <img
              className="ds-icon"
              title={dataSourceName}
              src={dataguard_icons[dataSourceType]}
              alt={dataSourceType}
            />
            <div title={dataSourceName}>{dataSourceName}</div>
          </div>
        );
      },
      sortComparator: sortText,
    },
    {
      field: "ipAddress",
      headerName: "IP Address",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params),
      sortComparator: (v1, v2) => {
        const a = v1?.toString() || "";
        const b = v2?.toString() || "";
        return a.localeCompare(b, undefined, { numeric: true });
      },
    },
    {
      field: "opType",
      headerName: "Operation Type",
      flex: operationTypeFlex,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderOperationType(params),
      sortComparator: sortText,
    },
    {
      field: "fName",
      headerName: "File Name",
      flex: fileNameFlex,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderFileName(params),
      sortComparator: sortText,
    }
  ];
    
  return hideDataSource ? columns.filter(col => col.field !== "dataSourceName") : columns;
};

// ── Users page — country drill-down columns ────────────────────────────────
// Response shape: { time, username, ipAddress, accessDetail,
//                   city, country, dataSourceName, dataSourceType, ... }
export const usersCountryColumns = (isIncognito, hideDataSource = false) => {
  const columns = [
    {
      field: "date",
      headerName: "Date",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("MM-DD-YYYY");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "time",
      headerName: "Time",
      flex: 1.2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        return moment.utc(params?.row?.time).format("HH:mm");
      },
      sortComparator: (v1, v2, param1, param2) => {
        const time1 = moment.utc(param1?.row?.time || param1?.value || v1);
        const time2 = moment.utc(param2?.row?.time || param2?.value || v2);
        return time1.valueOf() - time2.valueOf();
      },
    },
    {
      field: "username",
      headerName: "User Name",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => RenderUserName(params, isIncognito),
      sortComparator: sortText,
    },
    // {
    //   field: "dataSourceName",
    //   headerName: "Data Source",
    //   flex: 2,
    //   align: "left",
    //   headerAlign: "left",
    //   renderCell: (params) => {
    //     if (isNull(params.value) || isEmpty(params.value)) {
    //       return renderNull();
    //     }
    //     const dataSourceType = params.row.dataSourceType;
    //     const dataSourceName = params.value;
    //     return (
    //       <div className="data-guard-accordion-type ds-col-container">
    //         <img
    //           className="ds-icon"
    //           title={dataSourceName}
    //           src={dataguard_icons[dataSourceType]}
    //           alt={dataSourceType}
    //         />
    //         <div title={dataSourceName}>{dataSourceName}</div>
    //       </div>
    //     );
    //   },
    //   sortComparator: sortText,
    // },
    {
      field: "ipAddress",
      headerName: "IP Address",
      flex: 2,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params),
      sortComparator: (v1, v2) => {
        const a = v1?.toString() || "";
        const b = v2?.toString() || "";
        return a.localeCompare(b, undefined, { numeric: true });
      },
    },
    {
      field: "city",
      headerName: "City",
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderNormalText(params),
      sortComparator: sortText,
    },
    {
      field: "accessDetail",
      headerName: "Access Detail",
      flex: 3,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => renderStmt(params),
      sortComparator: sortText,
    },
  ];

  return hideDataSource ? columns.filter(col => col.field !== "dataSourceName") : columns;
};